import React, { useMemo, useState } from "react";
import { Dropdown, IDropdownOption, PrimaryButton, Text } from "@fluentui/react";

const baseApi = process.env.REACT_APP_ZedXApiBaseUrl!;

export const DemoCustomerAccessPanel: React.FC = () => {

    const [errorText, setErrorText] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedCustomer, setSelectedCustomer] = useState<string>("");
    const [statusMessage, setStatusMessage] = useState<string>("");

    // Read from env
    const demoCustomers = process.env.REACT_APP_DEMO_CUSTOMERS || "";

    // Parse list
    const customerList = useMemo(() => {
        return demoCustomers
            .split(",")
            .map(c => c.trim())
            .filter(c => c.length > 0);
    }, [demoCustomers]);

    // Build dropdown options
    const dropdownOptions: IDropdownOption[] = customerList.map(c => ({
        key: c,
        text: `${c}-z`
    }));

    // Ensure default selection (first item)
    React.useEffect(() => {
        if (customerList.length > 0 && !selectedCustomer) {
            setSelectedCustomer(customerList[0]);
        }
    }, [customerList, selectedCustomer]);

    const authType = "-z";

    const onContinue = async () => {

        setErrorText("");
        setStatusMessage("");

        if (!selectedCustomer) {
            setErrorText("Please select a demo customer.");
            return;
        }

        try {

            setIsLoading(true);
            setStatusMessage("Creating your demo account...");

            // 1. Create demo user
            const createResponse = await fetch(
                `${baseApi}/users/CreateDemoUser?customerRef=${selectedCustomer}`,
                { method: "POST" }
            );

            if (!createResponse.ok) {
                throw new Error("Failed to create demo user");
            }

            setStatusMessage("Preparing to redirect to login...");

            // 2. Proceed with existing flow
            const response = await fetch(
                `${baseApi}/customers/getcustomerinfo?c=${selectedCustomer}&environment=TEST&authType=${authType}`
            );

            const data = await response.json();

            if (data.RedirectAddressMSAuth !== "" && data.RedirectAddressCustomAuth !== "") {

                const redirectAddress = data.RedirectAddressCustomAuth;

                window.location.href =
                    `${redirectAddress}?c=_${selectedCustomer}${authType}`;

            } else {

                const errMsg = data.ErrMsg || "Customer not found.";
                setErrorText(errMsg);
                setStatusMessage("");
                setIsLoading(false);

            }

        } catch (error) {

            console.error("Error:", error);
            setErrorText("Something went wrong.");
            setStatusMessage("");
            setIsLoading(false);

        }
    };

    return (

        <div style={{ paddingLeft: '5px', maxWidth: "600px" }}>

            <h2 style={{ color: "rgb(112,146,190)", fontWeight: 400 }}>
                Demo Access
            </h2>

            <p>
                This is a demo environment. Click continue to proceed.
            </p>

            <div style={{ marginTop: 30 }}>

                <Text variant="mediumPlus">
                    Demo Customer ID
                </Text>

                <Dropdown
                    options={dropdownOptions}
                    selectedKey={selectedCustomer}
                    onChange={(e, option) => setSelectedCustomer(option?.key as string)}
                    style={{
                        width: "100%",
                        maxWidth: 400,
                        marginTop: 8
                    }}
                />

                {errorText && (
                    <div style={{ color: "red", marginTop: 8 }}>
                        {errorText}
                    </div>
                )}

                {statusMessage && (
                    <div style={{ color: "rgb(112, 146, 190)", marginTop: 8, fontWeight: 500 }}>
                        {statusMessage}
                    </div>
                )}

            </div>

            <div style={{ marginTop: 30 }}>
                <PrimaryButton
                    text="Continue"
                    onClick={onContinue}
                    disabled={isLoading || !selectedCustomer}
                />
            </div>

        </div>
    );
};